module.exports = __webpack_public_path__ + "components/AppFeature/Icon_THB.png";